module.exports = __webpack_public_path__ + "static/media/bigLeaf.842b9657.png";